import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import ProtectedRoute     from './components/ProtectedRoute';
import Layout             from './components/Layout';
import LoginPage          from './pages/LoginPage';
import RegisterPage       from './pages/RegisterPage';
import DashboardPage      from './pages/DashboardPage';
import AskUsPage          from './pages/AskUsPage';
import AdminQueriesPage   from './pages/AdminQueriesPage';
import FeedbackPage       from './pages/FeedbackPage';
import ContactPage        from './pages/ContactPage';
import SupportPage        from './pages/SupportPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public auth routes */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Public shell — no login required */}
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard/technology" replace />} />
            <Route path="/dashboard/:category" element={<DashboardPage />} />
            <Route path="/contact"             element={<ContactPage />} />
            <Route path="/support"             element={<SupportPage />} />

            {/* Login required */}
            <Route element={<ProtectedRoute />}>
              <Route path="/ask-us"        element={<AskUsPage />} />
              <Route path="/feedback"      element={<FeedbackPage />} />
              <Route path="/admin/queries" element={<AdminQueriesPage />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
